import React, { useState } from 'react';
import './Contact.css';

export default function Contact() {
  const [form, setForm] = useState({ name:'', email:'', subject:'', message:'' });
  const [errors, setErrors] = useState({});
  const [sent, setSent] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.name.trim()) e.name = 'Name is required';
    if (!form.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) e.email = 'Valid email required';
    if (!form.subject) e.subject = 'Please select a subject';
    if (form.message.trim().length < 20) e.message = 'Message must be at least 20 characters';
    return e;
  };

  const handleChange = e => {
    setForm(f => ({...f, [e.target.name]: e.target.value}));
    if (errors[e.target.name]) setErrors(er => ({...er, [e.target.name]: ''}));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setSent(true);
  };

  if (sent) return (
    <main className="contact-page" style={{ paddingTop: '60px' }}>
      <div className="container">
        <div className="success-box">
          <div className="success-icon">✓</div>
          <h2>Message Sent!</h2>
          <p>Thanks <strong>{form.name}</strong>! We'll reply to <strong>{form.email}</strong> within 1–2 business days.</p>
          <button className="submit-btn" onClick={() => { setSent(false); setForm({ name:'', email:'', subject:'', message:'' }); }}>Send Another</button>
        </div>
      </div>
    </main>
  );

  return (
    <main className="contact-page" style={{ paddingTop: '60px' }}>
      <section className="contact-hero">
        <div className="container">
          <div className="contact-badge">Contact</div>
          <h1>Get in Touch</h1>
          <p>Have a question, bug report, or feature idea? We respond to every message within 1–2 business days.</p>
        </div>
      </section>
      <div className="container contact-content">
        <div className="contact-grid">
          <div className="form-wrap">
            <h2>Send a Message</h2>
            <form onSubmit={handleSubmit} noValidate className="cform">
              <div className="form-row">
                <div className={`field ${errors.name ? 'err' : ''}`}>
                  <label>Full Name</label>
                  <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Jane Doe" />
                  {errors.name && <span className="field-err">{errors.name}</span>}
                </div>
                <div className={`field ${errors.email ? 'err' : ''}`}>
                  <label>Email Address</label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="jane@example.com" />
                  {errors.email && <span className="field-err">{errors.email}</span>}
                </div>
              </div>
              <div className={`field ${errors.subject ? 'err' : ''}`}>
                <label>Subject</label>
                <select name="subject" value={form.subject} onChange={handleChange}>
                  <option value="">Select a topic…</option>
                  <option value="bug">Bug Report</option>
                  <option value="feature">Feature Request</option>
                  <option value="question">General Question</option>
                  <option value="partnership">Partnership</option>
                  <option value="other">Other</option>
                </select>
                {errors.subject && <span className="field-err">{errors.subject}</span>}
              </div>
              <div className={`field ${errors.message ? 'err' : ''}`}>
                <label>Message</label>
                <textarea name="message" value={form.message} onChange={handleChange} rows={6} placeholder="Describe your question or feedback in detail…" />
                <div className="char-count">{form.message.length} characters</div>
                {errors.message && <span className="field-err">{errors.message}</span>}
              </div>
              <button type="submit" className="submit-btn">Send Message →</button>
            </form>
          </div>
          <aside className="contact-sidebar">
            {[
              { icon: '📬', title: 'Response Time', text: 'We typically respond within 1–2 business days. Mark your subject "Urgent" for time-sensitive issues.' },
              { icon: '🐛', title: 'Bug Reports', text: 'Include your browser, OS, device type, and steps to reproduce. Screenshots are very helpful.' },
              { icon: '💡', title: 'Feature Requests', text: 'We review all suggestions. Popular requests are prioritized in our next release cycle.' },
              { icon: '🔒', title: 'Privacy', text: 'Your contact info is used only to reply to your message. We never share it with third parties.' },
            ].map((c, i) => (
              <div key={i} className="info-card">
                <span className="info-icon">{c.icon}</span>
                <div>
                  <div className="info-title">{c.title}</div>
                  <div className="info-text">{c.text}</div>
                </div>
              </div>
            ))}
          </aside>
        </div>
      </div>
    </main>
  );
}
